import { useParams } from 'react-router-dom';

import { useGetGame } from '@/api/getGames';
import type { Game } from '@/models/game';

export const useGame = (): Game => {
  const { gameId: gameCode } = useParams();
  if (gameCode == null) {
    throw new Error('Game ID is required'); //developer error, should never happen
  }

  const { data: game } = useGetGame(gameCode);

  if (!game) {
    throw new Error(`Game ${gameCode} not found`); //developer error, should never happen
  }

  return game;
};
